import { render, staticRenderFns } from "./EditNotification.vue?vue&type=template&id=a235304a&scoped=true&"
import script from "./EditNotification.vue?vue&type=script&lang=ts&"
export * from "./EditNotification.vue?vue&type=script&lang=ts&"
import style0 from "./EditNotification.vue?vue&type=style&index=0&id=a235304a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a235304a",
  null
  
)

export default component.exports